/**
 * ZAPS Inline SVG Icons
 * Webpack-compatible — no external dependencies.
 * Paths sourced from Lucide (MIT licence).
 */
import React from 'react';

/* ── Base SVG wrapper ── */
function Icon(_ref) {
  var size        = _ref.size       || 16;
  var strokeWidth = _ref.strokeWidth|| 1.8;
  var color       = _ref.color      || 'currentColor';
  var className   = _ref.className  || '';
  var style       = _ref.style      || {};
  var children    = _ref.children;
  return React.createElement('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    width: size, height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className: className,
    style: style,
  }, children);
}

/* ── Individual icons ── */

export function LayoutDashboard(p) {
  return React.createElement(Icon, p,
    React.createElement('rect', { width:'7', height:'9', x:'3',  y:'3',  rx:'1' }),
    React.createElement('rect', { width:'7', height:'5', x:'14', y:'3',  rx:'1' }),
    React.createElement('rect', { width:'7', height:'9', x:'14', y:'12', rx:'1' }),
    React.createElement('rect', { width:'7', height:'5', x:'3',  y:'16', rx:'1' }),
  );
}

export function UserPlus(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' }),
    React.createElement('circle', { cx:'9', cy:'7', r:'4' }),
    React.createElement('line', { x1:'19', x2:'19', y1:'8', y2:'14' }),
    React.createElement('line', { x1:'22', x2:'16', y1:'11', y2:'11' }),
  );
}

export function CheckCircle(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M22 11.08V12a10 10 0 1 1-5.93-9.14' }),
    React.createElement('polyline', { points:'22 4 12 14.01 9 11.01' }),
  );
}

export function Clock(p) {
  return React.createElement(Icon, p,
    React.createElement('circle', { cx:'12', cy:'12', r:'10' }),
    React.createElement('polyline', { points:'12 6 12 12 16 14' }),
  );
}

export function ThumbsUp(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M7 10v12' }),
    React.createElement('path', { d:'M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z' }),
  );
}

export function FileText(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z' }),
    React.createElement('polyline', { points:'14 2 14 8 20 8' }),
    React.createElement('line', { x1:'16', x2:'8', y1:'13', y2:'13' }),
    React.createElement('line', { x1:'16', x2:'8', y1:'17', y2:'17' }),
    React.createElement('line', { x1:'10', x2:'8', y1:'9',  y2:'9'  }),
  );
}

export function Hourglass(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M5 22h14' }),
    React.createElement('path', { d:'M5 2h14' }),
    React.createElement('path', { d:'M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22' }),
    React.createElement('path', { d:'M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2' }),
  );
}

export function BadgeCheck(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z' }),
    React.createElement('path', { d:'m9 12 2 2 4-4' }),
  );
}

export function Building2(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z' }),
    React.createElement('path', { d:'M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2' }),
    React.createElement('path', { d:'M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2' }),
    React.createElement('path', { d:'M10 6h4' }),
    React.createElement('path', { d:'M10 10h4' }),
    React.createElement('path', { d:'M10 14h4' }),
    React.createElement('path', { d:'M10 18h4' }),
  );
}

export function XCircle(p) {
  return React.createElement(Icon, p,
    React.createElement('circle', { cx:'12', cy:'12', r:'10' }),
    React.createElement('path', { d:'m15 9-6 6' }),
    React.createElement('path', { d:'m9 9 6 6' }),
  );
}

export function Activity(p) {
  return React.createElement(Icon, p,
    React.createElement('polyline', { points:'22 12 18 12 15 21 9 3 6 12 2 12' }),
  );
}

export function BarChart2(p) {
  return React.createElement(Icon, p,
    React.createElement('line', { x1:'18', x2:'18', y1:'20', y2:'10' }),
    React.createElement('line', { x1:'12', x2:'12', y1:'20', y2:'4'  }),
    React.createElement('line', { x1:'6',  x2:'6',  y1:'20', y2:'14' }),
  );
}

export function PlusCircle(p) {
  return React.createElement(Icon, p,
    React.createElement('circle', { cx:'12', cy:'12', r:'10' }),
    React.createElement('line', { x1:'12', x2:'12', y1:'8', y2:'16' }),
    React.createElement('line', { x1:'8',  x2:'16', y1:'12', y2:'12' }),
  );
}

export function Eye(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z' }),
    React.createElement('circle', { cx:'12', cy:'12', r:'3' }),
  );
}

export function Users(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' }),
    React.createElement('circle', { cx:'9', cy:'7', r:'4' }),
    React.createElement('path', { d:'M22 21v-2a4 4 0 0 0-3-3.87' }),
    React.createElement('path', { d:'M16 3.13a4 4 0 0 1 0 7.75' }),
  );
}

export function MapPin(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z' }),
    React.createElement('circle', { cx:'12', cy:'10', r:'3' }),
  );
}

export function Network(p) {
  return React.createElement(Icon, p,
    React.createElement('rect', { x:'16', y:'16', width:'6', height:'6', rx:'1' }),
    React.createElement('rect', { x:'2',  y:'16', width:'6', height:'6', rx:'1' }),
    React.createElement('rect', { x:'9',  y:'2',  width:'6', height:'6', rx:'1' }),
    React.createElement('path', { d:'M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3' }),
    React.createElement('path', { d:'M12 12V8' }),
  );
}

export function Wrench(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z' }),
  );
}

export function ChevronsLeft(p) {
  return React.createElement(Icon, p,
    React.createElement('polyline', { points:'11 17 6 12 11 7' }),
    React.createElement('polyline', { points:'18 17 13 12 18 7' }),
  );
}

export function ChevronsRight(p) {
  return React.createElement(Icon, p,
    React.createElement('polyline', { points:'13 17 18 12 13 7' }),
    React.createElement('polyline', { points:'6 17 11 12 6 7' }),
  );
}

export function Menu(p) {
  return React.createElement(Icon, p,
    React.createElement('line', { x1:'4',  x2:'20', y1:'12', y2:'12' }),
    React.createElement('line', { x1:'4',  x2:'20', y1:'6',  y2:'6'  }),
    React.createElement('line', { x1:'4',  x2:'20', y1:'18', y2:'18' }),
  );
}

export function IdCard(p) {
  return React.createElement(Icon, p,
    React.createElement('rect', { width:'20', height:'14', x:'2', y:'5', rx:'2' }),
    React.createElement('circle', { cx:'8', cy:'12', r:'2' }),
    React.createElement('path', { d:'M14 11h4' }),
    React.createElement('path', { d:'M14 15h4' }),
    React.createElement('path', { d:'M2 10h20' }),
  );
}

export function LogOut(p) {
  return React.createElement(Icon, p,
    React.createElement('path', { d:'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' }),
    React.createElement('polyline', { points:'16 17 21 12 16 7' }),
    React.createElement('line', { x1:'21', x2:'9', y1:'12', y2:'12' }),
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons.js